import axios from "axios";
import { api } from "../services/Api";

export const SendPushNotification = async ({
  token,
  topic,
  title,
  body,
  screen,
  id,
  image,
  status,
}) => {
  // var data = JSON.stringify({
  //   data: {
  //     screen,
  //     id,
  //   },
  //   notification: {
  //     body,
  //     title,
  //   },
  //   to: token,
  // });

  // const options = {
  //   method: "POST",
  //   url: "https://fcm.googleapis.com/fcm/send",
  //   headers: {
  //     Authorization:
  //       "key=AAAAgnGlZts:APA91bF5IxHiauFHpLYi2j1H8hEI_hKXrBShk0QtGeJKTcmav_k3lzfnDc27-4CKGS98pvbcxReOiGYUWc-bdyXbwMVjCH9IYw52x9q_KR7_w0VjzCchinZIQ0QiPcciVF4yGLMzJUVE",
  //     "Content-Type": "application/json",
  //   },
  //   data: data,
  // };

  // try {
  //   axios
  //     .request(options)
  //     .then(function (response) {
  //       console.log(response.data);
  //     })
  //     .catch(function (error) {
  //       console.error(error);
  //     });
  // } catch (error) {
  //   console.log("error", error);
  // }

  api
    .get("/notifications/push-notification/access-token")
    .then((response) => {
      const accessToken = response.data; // Adjust this line according to the actual structure of your response

      var config = {
        method: "post",
        url: process.env.REACT_APP_FIREBASE_PN_URL,
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        data: {
          message: {
            ...(topic && { topic }),
            ...(token && { token }),
            notification: {
              body,
              title,
              image,
            },
            data: {
              screen,
              id: JSON.stringify(id),
              image,
              ...(status && { status }),
            },
          },
        },
      };

      axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data), "push notification sent");
        })
        .catch(function (error) {
          console.log("error", JSON.stringify(error));
        });
    })
    .catch((error) => {
      console.error("Failed to retrieve notification token:", error);
    });
};
